module.exports = __webpack_public_path__ + "img/icon_advantage_service@2x.a3d30f47.png";